import React from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'

export default function DeleteConfirm({setDeleteModal,deleteModal,delLoader,handleDelete,title}) {
  return (
         <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this {title}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={delLoader}
            onClick={handleDelete}
          >
            {delLoader ? <Spinner size="sm" /> : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
  )
}
